<template>
  <div
    :class="[
      'loader',
      overlay ? 'loader--overlay' : 'loader--embed',
      size === 'small' && !overlay && 'loader--embed-small'
    ]"
    role="status"
    aria-live="polite"
  >
    <div :class="['loader__inner', size === 'small' ? 'loader__inner--small' : 'loader__inner--large']">
      <div v-if="size === 'large'" class="loader__halo" aria-hidden="true" />
      <img :src="loadingSrc" alt="" class="loader__img" width="80" height="80" />
    </div>
    <span class="sr-only">{{ ariaLabel }}</span>
  </div>
</template>

<script>
import loadingSrc from "@/assets/img/loading.svg";

export default {
  name: "Loader",
  props: {
    /** Маленький — вместо кнопки / в строке; большой — блок и оверлей. */
    size: {
      type: String,
      default: "large",
      validator: (v) => v === "small" || v === "large"
    },
    /** Полноэкранный оверлей по центру вьюпорта. */
    overlay: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: "Загрузка"
    }
  },
  data() {
    return { loadingSrc };
  }
};
</script>

<style lang="scss" scoped>
.loader {
  &--overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0);
  }

  &--embed {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0;
  }

  &--embed-small {
    display: inline-flex;
    width: auto;
    vertical-align: middle;
  }
}

.loader__inner {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &--large {
    padding: 1rem;
  }

  &--small {
    padding: 0;
    height: auto;
    display: inline-flex;
  }
}

.loader__inner--large .loader__halo {
  position: absolute;
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
  background: rgba(245, 247, 251, 0.92);
  box-shadow: 0 8px 24px rgba(18, 35, 64, 0.08);
  z-index: 0;
}

.loader__img {
  position: relative;
  z-index: 1;
  width: 5rem;
  height: 5rem;
  display: block;
}

.loader__inner--small .loader__img {
  width: 1.5rem;
  height: 1.5rem;
}
</style>
